// admin/src/components/ResultContentCardPro.jsx
import React from 'react';

const DEGREE_LABELS = {
  all: 'All Levels',
  bachelors: "Bachelor's",
  masters: "Master's",
  doctorate: 'Doctorate',
  graduate: 'Graduate',
  certificate: 'Certificate',
  associate: 'Associate'
};

export default function ResultContentCardPro({ item, onEdit, onDelete }) {
  const img = item?.imageUrl || item?.image || '';
  
  const formatMindsetTag = (slug) => {
    if (!slug) return null;
    return slug
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const degreeTags = Array.isArray(item.degreeLevelTags) && item.degreeLevelTags.length > 0
    ? item.degreeLevelTags
    : null;

  return (
    <article className="adm-card">
      <div className="adm-card__header">
        {img ? (
          <img
            className="adm-thumb"
            src={img}
            alt={item.title}
            loading="lazy"
            width="240"
            height="160"
            onError={(e)=>{ e.currentTarget.style.visibility='hidden'; }}
          />
        ) : (
          <div className="adm-thumb adm-thumb--empty">No Image</div>
        )}
        <div className="adm-card__headtext">
          <div className="adm-title">{item.title || 'Untitled'}</div>
          <div className="adm-sub">
            <span style={{ fontFamily: 'monospace', fontSize: '0.85em' }}>
              {item.tag || <span className="adm-empty">no tag</span>}
            </span>
          </div>
        </div>
      </div>

      <div className="adm-card__body">
        <div className="adm-badgerow">
          <span className={`adm-badge ${item.enabled ? 'adm-badge--success' : 'adm-badge--muted'}`}>
            {item.enabled ? 'Enabled' : 'Disabled'}
          </span>
          <span className="adm-badge adm-badge--neutral">ID: {item._id?.slice(-6) || '–'}</span>
        </div>

        {/* Description */}
        {item.description && (
          <div className="adm-section">
            <div className="adm-section__title">Description</div>
            <div className="adm-desc">
              {item.description}
            </div>
          </div>
        )}

        {/* Degree Level Tags */}
        {degreeTags && (
          <div className="adm-section">
            <div className="adm-section__title">Degree Levels</div>
            <div className="adm-badgerow">
              {degreeTags.map(tag => (
                <span key={tag} className="adm-badge adm-badge--neutral">
                  🎓 {DEGREE_LABELS[tag] || tag}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Mindset Tags */}
        {(item.primaryMindset || item.secondaryMindset) && (
          <div className="adm-section">
            <div className="adm-section__title">Associated Mindsets</div>
            <div className="adm-badgerow">
              {item.primaryMindset && (
                <span className="adm-badge adm-badge--info" title="Primary Mindset">
                  🎯 {formatMindsetTag(item.primaryMindset)}
                </span>
              )}
              {item.secondaryMindset && (
                <span className="adm-badge adm-badge--info" title="Secondary Mindset" style={{ opacity: 0.8 }}>
                  ➕ {formatMindsetTag(item.secondaryMindset)}
                </span>
              )}
            </div>
          </div>
        )}

        {/* CTA */}
        {item.ctaUrl && (
          <div className="adm-section">
            <div className="adm-section__title">Call to Action</div>
            <div style={{ fontSize: '0.85rem' }}>
              <span style={{ fontWeight: 600 }}>{item.ctaLabel || 'Link'}</span>
              {' → '}
              <a href={item.ctaUrl} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all' }}>
                {item.ctaUrl}
              </a>
            </div>
          </div>
        )}

        {/* Show message if no description and no mindsets */}
        {!item.description && !item.primaryMindset && !item.secondaryMindset && (
          <div className="adm-section">
            <div className="adm-empty" style={{ fontStyle: 'italic', fontSize: '0.85rem' }}>
              No description or mindsets configured
            </div>
          </div>
        )}

        <div className="adm-actions">
          <button className="btn btn--ghost" onClick={onEdit}>Edit</button>
          <button className="btn btn--danger" onClick={onDelete}>Delete</button>
        </div>
      </div>
    </article>
  );
}